if (FS.showEx('sentryCrashReportingEx')) {
  //Reduce the number of errors.  We pay for each one or on the free plan
  //  they just stop reporting.
  var ravenOptions = {
    ignoreErrors: [
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      // Facebook borked
      'fb_xd_fragment',
      /.*Script error.*/,
      /.*requestAnimationFrame is not defined.*/,
      's is not defined',
      /.*_satellite.*/,
      /.*Blocked a frame with origin.*/,
      /.*NOT_AUTHENTICATED.*/,
      /.*status.*403.*/,
      /.*status.*404.*/,
      /.*status.*401.*/,
      /.*status\"\:-1.*/,
      /.*'minus' of undefined.*/,
      /.*Possibly unhandled rejection.*/
    ],
    sampleRate: 0.1
  };
  Raven
    .config('https://3afc6cce428946fcb4f82e0928d90e8c@sentry.io/124337', ravenOptions)
    .addPlugin(Raven.Plugins.Angular)
    .install();

    Raven.setUserContext({
      name: FS && FS.User && FS.User.profile ? FS.User.profile.displayName : "anonymous",
      username: FS && FS.User && FS.User.profile ? FS.User.profile.username : "anonymous",
      email: FS && FS.User && FS.User.profile ? FS.User.profile.displayName : "anonymous",
      id: FS && FS.User ? FS.User.sessionId : "nosession"
    });
}
